module.exports = __webpack_public_path__ + "img/horizontal_6_7_8023.efe332bd.png";